export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-gradient-to-br from-primary-500 via-primary-500 to-accent-500 p-8 md:p-12 text-center">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-background-50/20">
            <i className="ri-smartphone-line text-3xl text-background-50"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">
            随时随地看大片
          </h2>
          <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
            麻花影院全面适配手机、平板和电脑，打开浏览器即可观看。
            收藏本站，即可获得APP般的便捷观影体验。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-medium rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-bookmark-line"></i>
              收藏本站
            </a>
            <a
              href="#features"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#features');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 64;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 text-background-50 font-medium rounded-full border border-background-50/30 hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}